import { CampaignBriefEffects } from "./campaign-brief/store/campaign-brief.effects";
import { CampaignBriefsEffects } from "./campaign-briefs/store/campaign-briefs.effects";
import { ExecutionBriefEffects } from "./execution-brief/store/execution-brief.effects";
import { FlyerEffects } from "./flyer/store/flyer.effects";
import { WorkOrderEffects } from "./work-order/store/work-order.effects";

export const PagesEffects = [
  ...CampaignBriefEffects,
  ...CampaignBriefsEffects,
  ...ExecutionBriefEffects,
  ...FlyerEffects,
  ...WorkOrderEffects,
];
